import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import progressionReducer from "./reducers/progressionReducer";

const store = configureStore({
  reducer: { progression: progressionReducer },
});
export default function StoreProvider({ children }) {
  return <Provider store={store}>{children}</Provider>;
}
